import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../../config";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../redux/slices/snackbar";
import { useSelector } from "react-redux";
import {
  setVisureFilters,
  clearVisureFilters,
} from "../../../../redux/slices/visureFilters";

export const Data = () => {
  const [pageNumbers, setPageNumbers] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [visureRows, setVisureRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [isRemovingFilters, setIsRemovingFilters] = useState(false);
  const [isTableChanging, setIsTableChanging] = useState(false);
  const [barChartData, setBarChartData] = useState(null);
  const [canClearFilters, setCanClearFilters] = useState(false);
  const [clearTextField, setClearTextField] = useState(false);
  const filters = useSelector((state) => state.visureFilters);

  const dispatch = useDispatch();
  const handleSnackbar = (message, severity) => {
    dispatch(showSnackbar({ message, severity }));
  };

  const navigate = useNavigate();

  async function visureGetList(rowsPages, pageNumbers, ragioneSociale, piva) {
    const token = sessionStorage.getItem("token");
    const queryParams = new URLSearchParams();
    if (ragioneSociale) queryParams.append("ragioneSociale", ragioneSociale);
    if (piva) queryParams.append("piva", piva);

    const qs = queryParams.toString();

    const endpoint = `${API_BASE_URL}/api/visure/${rowsPages}/${pageNumbers}${
      qs ? `?${qs}` : ""
    }`;

    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      const response = await fetch(endpoint, requestOptions);

      const responseData = await response.json();
      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        handleSnackbar(responseData.message, "error");
        navigate("/private");
      }
      return responseData;
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
  setIsTableChanging(true);

  visureGetList(
    rowsPerPage,
    pageNumbers,
    filters?.ragioneSociale || "",
    filters?.piva || ""
  )
    .then((response) => {
      if (response.status === 1) {
        setTotalRows(response?.data?.totalRows);
        setVisureRows(response?.data?.dataset);
        setBarChartData(response?.data?.graphBarData);
      }
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      setIsTableChanging(false);
    });
}, [pageNumbers, rowsPerPage, filters]);

  const handlePageChange = (newPage) => {
    if (isTableChanging) {
      return;
    } else {
      setPageNumbers(newPage + 1);
    }
  };

  // function that changes the table rows (size)
  const handlePageSizeChange = (newPageSize) => {
    setRowsPerPage(newPageSize);
    setPageNumbers(1);
  };

  const handleApplyFilters = (ragioneSociale, piva) => {
    dispatch(
    setVisureFilters({
      ragioneSociale,
      piva,
    })
  );

    setFiltersLoading(true);
    setIsTableChanging(true);
    setClearTextField(false);
    visureGetList(rowsPerPage, pageNumbers, ragioneSociale, piva)
      .then((response) => {
        if (response.status === 1) {
          setTotalRows(response?.data?.totalRows);
          setVisureRows(response?.data?.dataset);
          setBarChartData(response?.data?.graphBarData);
          setCanClearFilters(true);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setFiltersLoading(false);
        setIsTableChanging(false);
      });
  };

  const handleRemoveFilters = () => {
    dispatch(clearVisureFilters());
    
    setIsRemovingFilters(true);
    setIsTableChanging(true);
    setClearTextField(true);
    visureGetList(rowsPerPage, pageNumbers, "", "")
      .then((response) => {
        if (response.status === 1) {
          setTotalRows(response?.data?.totalRows);
          setVisureRows(response?.data?.dataset);
          setBarChartData(response?.data?.graphBarData);
          setCanClearFilters(false);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRemovingFilters(false);
        setIsTableChanging(false);
      });
  };

  return {
    visureRows,
    totalRows,
    pageNumbers,
    rowsPerPage,
    handleApplyFilters,
    handleRemoveFilters,
    filtersLoading,
    isRemovingFilters,
    handlePageChange,
    handlePageSizeChange,
    barChartData,
    canClearFilters,
    clearTextField,
  };
};
